import BuyInstoreScreen from "./BuyInstoreScreen";
import BuyOnlineScreen from "./BuyOnlineScreen";
import OnlineOfferDetailScreen from "./OnlineOfferDetailScreen";
import InstoreOfferDetailScreen from "./InstoreOfferDetailScreen";
import { createStackNavigator } from "@react-navigation/stack";
import React from "react";

const Stack = createStackNavigator();

export default function buyNavigationStack() {
    return (
        <>
            <Stack.Screen
                name="BuyInstore"
                component={BuyInstoreScreen}
                options={{ headerShown: false }}
              />
              <Stack.Screen
                name="BuyOnline"
                component={BuyOnlineScreen}
                options={{ headerShown: false }}
              />
              <Stack.Screen
               name="OnlineOfferDetails"
               component={OnlineOfferDetailScreen}
               options={{ headerShown: false }}
             />
             <Stack.Screen
               name="InstoreOfferDetails"
               component={InstoreOfferDetailScreen}
               options={{ headerShown: false }}
             />
        </>
    )
}